import { Module } from 'vuex';
import { contractManagementFolders } from '../folders/store/folders.store';
import { getDefaultState } from './contract-management.constants';
import { IContractManagementState } from './contract-management.types';
import { actions } from '@/contract-management/store/contract-management.actions';
import { getters } from '@/contract-management/store/contract-management.getters';
import { mutations } from '@/contract-management/store/contract-management.mutations';
import { RootState } from '@/store/store';

export const contractManagement: Module<IContractManagementState, RootState> = {
  getters,
  actions,
  namespaced: true,
  mutations,
  state: getDefaultState(),
  modules: {
    contractManagementFolders,
  },
};
